import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { selectors } from "reducers";
import { path } from "ramda";
import { useFetch } from "hooks";
import { get } from "utils/api";
import * as msg from "actions/message";
import { getApiErrorMessage } from "utils/misc";
import PropTypes from "prop-types";
import PatientsTable from "./patients-table";
import CoachStatsPatientTypeOutreach from "./coach-stats-patient-type-outreach";
import PhoneNumberPrompt from "components/two-factor-auth/phone-number-prompt";

const PatientTypeOutreach = ({ userRole, user, patientType, patientTypeByte }) => {
    const dispatch = useDispatch();
  const [ onboardingCoachFilterOptions, setOnboardingCoachFilterOptions ] = useState([]);

  const { fetchData: fetchOnboardingCoaches } = useFetch({
    apiFn: () => get(`patients/onboarding_coaches`),
    defaultValue: {},
    transformError: path(["response", "body", "status"]),
    onError: error => {
      dispatch(
        msg.errorMessage(
          `Failed to get Onboarding Coaches: ${getApiErrorMessage(error)}`
        )
      );
    }
  });

  const OnboardingCoach = async () => {
    const response = await fetchOnboardingCoaches();
    if (response) {
      setOnboardingCoachFilterOptions(response);
    }
  };

  useEffect(() => {
    OnboardingCoach();
  }, []);

  return (
    userRole != "ContractorAdministrator" && (
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <PhoneNumberPrompt user={user} />
        <CoachStatsPatientTypeOutreach patientType={patientType} patientTypeByte={patientTypeByte} />
          <PatientsTable
            initialQuery={{
              sort: {
                by: "last_name",
                direction: "asc"
              },
              pagination: {
                page: 1,
                per: 500
              },
              filter_by: { by: "patientType", value: patientTypeByte }
            }}
            patientTypeCoachOptions={onboardingCoachFilterOptions}
            patientType={patientType}
            patientTypeByte={patientTypeByte}
          />
      </div>
    )
  );
};

export default connect(state => ({
  userRole: selectors.getUserRole(state),
  user: selectors.getUser(state)
}))(PatientTypeOutreach);

PatientTypeOutreach.propTypes = {
  userRole: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  patientType: PropTypes.string.isRequired,
  patientTypeByte: PropTypes.number.isRequired
};
